import { throttle } from 'lodash/fp';
import { MutableRefObject, useCallback, useEffect, useState } from 'react';

export default function useHasScrolled(containerRef: MutableRefObject<HTMLDivElement>) {
  const [hasScrolled, setHasScrolled] = useState(false);

  const checkHasScrolled: () => void = useCallback(() => {
    if (containerRef.current != null) {
      const hasContainerScrolled = containerRef.current.scrollTop > 0;
      if (hasContainerScrolled !== hasScrolled) {
        setHasScrolled(hasContainerScrolled);
      }
    }
  }, [containerRef, setHasScrolled, hasScrolled]);

  const throttledScroll = throttle(200, checkHasScrolled);

  useEffect(() => {
    if (containerRef.current == null) {
      setHasScrolled(false);
      return;
    }
    const scrollContainer = containerRef.current;
    scrollContainer.addEventListener('scroll', throttledScroll);
    return () => scrollContainer.removeEventListener('scroll', throttledScroll);
  }, [containerRef, throttledScroll, checkHasScrolled]);

  return [hasScrolled];
}
